<template>
    <div class="news-list uk-grid uk-grid-large" uk-grid  uk-scrollspy="target: > *; cls: uk-animation-fade uk-animation-slide-bottom-small; delay: 250">
        <div v-for="item in items" class="uk-width-1-2@s uk-width-1-3@m">
          <div class="news-card news-card--vertical@tablet" :class="{ focus: item.focus}" data-uk-rr-grid-item>
            <a class="news-card__link" :href="item.url" :title="item.title">
              <div class="news-card__media-wrapper" v-if="item.featured_media">
                <div class="news-card__media" v-html="item.featured_media.data.thumbnail"></div>
              </div>
              <div class="news-card__body">
                <div class="news-card__meta">
                  <!--<div class="news-card__label" v-if="item.categories">
                    <span v-for="category in item.categories.data">{{category.present}}</span>
                  </div>-->
                  <time class="news-card__date" :datetime="item.published_at.value">{{item.published_date}}</time>
                </div>
                <h3 class="news-card__title">{{item.title}}</h3>
                <!--<p v-if="item.abstract" class="news-card__text">{{item.abstract}}</p>-->
              </div>
            </a>
          </div>
        </div>
    </div>
</template>
<script>
  import DataGridResults from 'js/theme-mixins/DataGridResults';

  export default {
    mixins: [DataGridResults],
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/imbotex/extensions/rubinred/collections/assets/js/NewsDataGridResults.vue